import UnsubscriptionCampaignsList from './UnsubscriptionCampaignsList'

export default UnsubscriptionCampaignsList
